<template>
  <div class="duobi_house">
    <public-header v-if="showHeader && showView"></public-header>
    <public-search v-if="showMenu && showView"></public-search>
    <public-menu v-if="showMenu && showView"></public-menu>

    <router-view v-if="showView"></router-view>
    <div v-else class="mask" v-loading="!showView" element-loading-text="拼命加载中"></div>

    <public-footer v-if="showFooter" bColor="#f1f1f1"></public-footer>
  </div>
</template>

<script>
import {
  GetSimpleUserInfo,
  CheckEShopLogin,
} from "@/pages/page1/api/modules/user";
import onlyMessage from "@/pages/publicUtils/resetMessage.js";
export default {
  data() {
    return {
      showView: false, //为了先获取数据再存储数据 vuex里面的数据在router-view有用到
      showHeader: true,
      showMenu: true,
      showFooter: false,
    };
  },
  mounted() {
    // if (this.$cookies.isKey("ACCESS_TOKEN")) {
    //   this.getUserInfo();
    // } else {
    //   this.initShow();
    // }
    this.getShopInfo();
  },
  methods: {
    getShopInfo() {
      // 接口实现 避免预渲染首页重定向到登录页
      CheckEShopLogin()
        .then((res) => {
          if (this.$cookies.isKey("ACCESS_TOKEN")) {
            this.getUserInfo();
          } else {
            // this.initShow();
            this.redirectLogin();
          }
        })
        .catch(() => {
          onlyMessage.error("请先登录");
          this.redirectLogin();
        });
    },
    getUserInfo() {
      GetSimpleUserInfo({}).then((res) => {
        // console.log("获取用户信息", res);
        this.$store.commit("SET_USERINFO", res.data[0] || {});
        this.initShow();
      });
    },
    initShow() {
      // setTimeout(() => {
      this.showView = true;
      this.setHeaderShow();
      this.setMenuShow();
      this.setFooterShow();
      // }, 10000);
    },
    redirectLogin() {
      this.$router.replace({
        path: "/login",
        query: {
          redirect: this.$route.fullPath,
        },
      });
    },
    // 是否显示header
    setHeaderShow() {
      let path = this.$route.path.toLowerCase();
      if (path === "/payDown".toLowerCase()) {
        this.showHeader = false;
        return;
      }
      if (path === "/printOrder".toLowerCase()) {
        this.showHeader = false;
        return;
      }
      this.showHeader = true;
    },
    // 是否显示menu
    setMenuShow() {
      let path = this.$route.path.toLowerCase();
      if (path === "/helpWord".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/shopCart".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/placeOrder".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/payType".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/platePay".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/orderPay".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/wechatPay".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/payDown".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      if (path === "/successPay".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      // 个人中心特殊
      if (path.indexOf("/personalcenter") != -1) {
        this.showMenu = false;
        return;
      }
      if (path === "/printOrder".toLowerCase()) {
        this.showMenu = false;
        return;
      }
      this.showMenu = true;
    },
    // 是否显示footer
    setFooterShow() {
      let path = this.$route.path.toLowerCase();
      if (path === "/wholeBag/wholeBagDetail".toLowerCase()) {
        this.showFooter = false;
        return;
      }
      if (path === "/electricBag/electricBagDetail".toLowerCase()) {
        this.showFooter = false;
        return;
      }
      if (path === "/shopCart".toLowerCase()) {
        this.showFooter = false;
        return;
      }
      if (path === "/payDown".toLowerCase()) {
        this.showFooter = false;
        return;
      }
      if (path === "/printOrder".toLowerCase()) {
        this.showFooter = false;
        return;
      }
      this.showFooter = true;
    },
  },
};
</script>
<style lang="less" scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
}
</style>